import React from "react"
import BaseHeadline from "../common/BaseHeadline"
import { ContactPersonCardsType, ImageType } from "../../types/mainModulTypes"
import BaseSubheadline from "../common/BaseSubheadline"
import { Divider } from "react-daisyui"
import { API } from "../../constants/constants"
import BaseRichtext from "../common/BaseRichtext"

export default function ContactPersonCards(props: ContactPersonCardsType) {
    return (
        <div className="max-w-content mx-auto px-4 lg:px-0 text-center">
            <BaseHeadline headlineType={3} label={props.contactPersonCardsHeading} />
            <BaseSubheadline label={props.contactPersonCardsSubHeading} />
            <div
                className={`flex flex-col ${
                    props.contactPersonCardsAlignment ? "md:flex-row" : "sm:flex-row "
                } justify-center items-center sm:items-stretch flex-wrap gap-8 pt-8`}>
                {props.contactPersonCardsBlock.map((card, index) => (
                    <>
                        {props.contactPersonCardsAlignment ? (
                            <HorizontalCard key={index} {...card.contactPersonCardsSelectionContact} />
                        ) : (
                            <VerticalCard key={index} {...card.contactPersonCardsSelectionContact} />
                        )}
                    </>
                ))}
            </div>
        </div>
    )
}

type cardType = {
    firstName: string
    lastName: string
    title: string
    fullName: string
    position: string
    avatar: ImageType
    mainEmail: string
    mainPhone: string
    mainFax: string
    mainAddress: {
        addition: string
        street: string
        number: string
        zip: string
        city: string
        title?: string
    }
}

function VerticalCard(props: cardType) {
    const numbers = props.mainPhone
        ?.split(",")
        .map((num) => num.trim())
        .filter((num) => num !== "")

    const landline = numbers && numbers[0] ? numbers[0] : ""
    const mobile = numbers && numbers[1] ? numbers[1] : ""

    return (
        <div className="flex flex-col items-center p-8 rounded-xl bg-primary w-80 lg:w-[31%] gap-4">
            <img
                src={API + props.avatar?.url}
                alt={props.avatar?.description || props.avatar?.name}
                className="rounded-full w-48 h-48 object-cover object-top"
            />
            <div>
                <BaseRichtext classProps="!text-lg font-semibold" content={props?.position + ":"} />
                <BaseRichtext content={[props.title, props.fullName].filter(Boolean).join(" ")} classProps="!text-lg" />
                {props.mainAddress.title && <BaseRichtext linksNotInPrimary content={props.mainAddress.title} classProps="!text-sm font-semibold" />}
                {landline && <BaseRichtext linksNotInPrimary content={"Tel: <a href='tel:" + landline + "'>" + landline + "</a>"} classProps="!text-base pt-4" />}
                {mobile && <BaseRichtext linksNotInPrimary content={"Mobil: <a href='tel:" + mobile + "'>" + mobile + "</a>"} classProps="!text-base" />}
                {props.mainFax && <BaseRichtext linksNotInPrimary content={"Fax: " + props.mainFax} classProps="!text-base" />}
                {props.mainEmail && (
                    <BaseRichtext linksNotInPrimary content={"E-Mail: <a href='mailto:" + props.mainEmail + "'>" + props.mainEmail + "</a>"} classProps=" !text-base" />
                )}
            </div>
        </div>
    )
}

function HorizontalCard(props: cardType) {
    return (
        <div className="flex flex-col sm:flex-row items-center p-4 rounded-xl border-4 border-white w-full md:w-auto lg:w-[48%]  gap-4">
            <img
                src={API + props.avatar?.url}
                alt={props.avatar?.description || props.avatar?.name}
                className="rounded-full w-24 h-24 sm:w-40 sm:h-40 object-cover"
            />
            <div className="text-center sm:text-left">
                <BaseRichtext classProps="!text-lg font-semibold" content={props.position + ":"} />
                <BaseRichtext content={[props.title, props.fullName].filter(Boolean).join(" ")} classProps="!text-lg pb-4" />

                {props.mainEmail && (
                    <BaseRichtext content={"E-Mail: <a href='mailto:" + props.mainEmail + "'>" + props.mainEmail + "</a>"} classProps="!text-base" />
                )}
            </div>
        </div>
    )
}
